<template>
  <v-container id="perdas-aic-historico" tag="section" fluid>
    <v-row>
      <v-col cols="12">
        <perdas-aic-tabela
          :items="items"
          :loading="loading"
          @rechargeTable="getAll()"
          @switchProcessamentosExpirados="((processamentosExpirados = $event), getAll())"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
  
<script>
  import PerdasAicService from '@/services/PerdasAicService';
  import pusherMixins from '@/mixins/pusherMixins';
  import dayjs from 'dayjs';

  export default {
    components: {
      PerdasAicTabela: () => import('@/components/perdasAic/Tabela.vue')
    },
    mixins: [pusherMixins],

    data() {
      return {
        items: [],
        loading: false,
        processamentosExpirados: false
      };
    },

    mounted() {
      this.subscribe();
      this.getAll();
    },

    methods: {
      subscribe() {
        this.pusherChannel.bind('refreshPerdasAic', () => {
          this.getAll();
        });
      },
      getAll() {
        this.loading = true;

        PerdasAicService.getAll(this.processamentosExpirados)
          .then((response) => {
            this.items = [];

            response.data.perdas.forEach((element) => {
              this.items.push({
                id: element.id,
                titulo: element.titulo,
                obras: element.obras,
                centros_custo: element.centros_custo,
                tipos: element.tipos,
                data_lancamento_inicio: element.data_lancamento_inicio,
                data_lancamento_fim: element.data_lancamento_fim,
                percentuais: JSON.parse(element.percentuais),
                status: element.status,
                usuario: element.usuario.nome,
                usuario_id: element.usuario.id,
                created: element.created,
                executed: element.data_processamento ? dayjs(element.data_processamento).format('DD/MM/YYYY HH:mm') : '-'
              });
            });
          })
          .catch((err) => {
            this.$toast.error('Erro ao recuperar as Perdas Aic.', '', { position: 'topRight' });
            console.error(err);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  };
</script>
 
  